import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Params } from '@angular/router';

// must be used here as it needs to be awaited before the route loads

import { SportsUserSettings } from '@frontend/sports/common/client-config-data-access';
import { RedirectHelperService } from '@frontend/sports/navigation/core/feature/redirect';
import { MyBetsUrlParam } from '@frontend/sports/navigation/core/feature/url-helper';
import { firstValueFrom } from 'rxjs';

import { MyBetsSummaryService } from '../../my-bets-base/my-bets-summary.service';

@Injectable()
export class MyBetsGuard {
    constructor(
        private redirectHelperService: RedirectHelperService,
        private myBetsLoader: MyBetsSummaryService,
        private userSettings: SportsUserSettings,
    ) {}

    async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
        await firstValueFrom(this.userSettings.whenReady);
        await this.redirectToFilteredMybets(route.queryParams);

        return true;
    }

    private async redirectToFilteredMybets(params: Params): Promise<void> {
        await this.myBetsLoader.refresh();

        const target = this.myBetsLoader.summary.liveBetsCount
            ? MyBetsUrlParam.Live
            : this.myBetsLoader.summary.openBetsCount
              ? MyBetsUrlParam.Open
              : MyBetsUrlParam.Settled;

        this.redirectHelperService.goToMyBets(target, params);
    }
}
